import calls from '@/backend/api-calls'

const state = () => ({
  productBrands: ['Mitrex', 'Cladify'],
  products: [],
  selected: [],
  categories: [],
  types: [],
  subcategories: [],
  loading: false,
  pagination: {
    page: 1,
    pages: 1
  },
  filters: {
    product_category_id: null,
    product_brand: 'Cladify',
    name: null
  }
})

// getters
const getters = {
  productIds: state => {
    return state.products.map(d => d.id);
  }
}

// actions
const actions = {
  getCategories: ({commit}, parameters) => {
    return new Promise((resolve, reject) => {
      calls.productCategories.get(parameters)
        .then(resp => {
          commit("setCategories", resp.data.results);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  addCategory: ({commit}, data) => {
    return new Promise((resolve, reject) => {
      calls.productCategories.post(data)
        .then(resp => {
          commit(
            'app/setNotification', 
            { 
              status: true, 
              type: 'success',
              message: 'Category successfully added'
            }, { root: true }
          );
          commit("insertCategory", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  updateCategory: ({commit}, { categoryId, data }) => {
    return new Promise((resolve, reject) => {
      calls.productCategory.put(categoryId, data)
        .then(resp => {
          commit(
            'app/setNotification', 
            { 
              status: true, 
              type: 'success',
              message: 'Category successfully updated'
            }, { root: true }
          );
          commit("insertUpdatedCategory", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  deleteCategory: ({commit}, categoryId) => {
    return new Promise((resolve, reject) => {
      calls.productCategory.delete(categoryId)
        .then(resp => {
          commit(
            'app/setNotification', 
            { 
              status: true, 
              type: 'success',
              message: 'Category successfully deleted'
            }, { root: true }
          );
          commit("removeCategory", categoryId);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  getTypes: ({commit}, parameters) => {
    return new Promise((resolve, reject) => {
      calls.productTypes.get(parameters)
        .then(resp => {
          commit("setTypes", resp.data.results);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  addType: ({commit}, data) => {
    return new Promise((resolve, reject) => {
      calls.productTypes.post(data)
        .then(resp => {
          commit(
            'app/setNotification', 
            { 
              status: true, 
              type: 'success',
              message: 'Product Type successfully added'
            }, { root: true }
          );
          commit("insertType", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  updateType: ({commit}, { typeId, data }) => {
    return new Promise((resolve, reject) => {
      calls.productType.put(typeId, data)
        .then(resp => {
          commit(
            'app/setNotification', 
            { 
              status: true, 
              type: 'success',
              message: 'Product type successfully updated'
            }, { root: true }
          );
          commit("insertUpdatedType", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  deleteType: ({commit}, typeId) => {
    return new Promise((resolve, reject) => {
      calls.productType.delete(typeId)
        .then(resp => {
          commit(
            'app/setNotification', 
            { 
              status: true, 
              type: 'success',
              message: 'Type successfully deleted'
            }, { root: true }
          );
          commit("removeType", typeId);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  getSubcategories: ({commit}, parameters) => {
    return new Promise((resolve, reject) => {
      calls.productSubcategories.get(parameters)
        .then(resp => {
          commit("setSubcategories", resp.data.results);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  addSubcategory: ({commit}, data) => {
    return new Promise((resolve, reject) => {
      calls.productSubcategories.post(data)
        .then(resp => {
          commit(
            'app/setNotification', 
            { 
              status: true, 
              type: 'success',
              message: 'Subcategory successfully added'
            }, { root: true }
          );
          commit("insertSubcategory", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  updateSubcategory: ({commit}, { subcategoryId, data }) => {
    return new Promise((resolve, reject) => {
      calls.productSubcategory.put(subcategoryId, data)
        .then(resp => {
          commit(
            'app/setNotification', 
            { 
              status: true, 
              type: 'success',
              message: 'Subcategory successfully updated'
            }, { root: true }
          );
          commit("insertUpdatedSubcategory", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  deleteSubcategory: ({commit}, subcategoryId) => {
    return new Promise((resolve, reject) => {
      calls.productSubcategory.delete(subcategoryId)
        .then(resp => {
          commit(
            'app/setNotification', 
            { 
              status: true, 
              type: 'success',
              message: 'Subcategory successfully deleted'
            }, { root: true }
          );
          commit("removeSubcategory", subcategoryId);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  getProducts: ({commit}, parameters) => {
    commit("setLoading", true);

    return new Promise((resolve, reject) => {
      calls.products.get(parameters)
        .then(resp => {
          commit("setProducts", resp.data);
          commit("setLoading", false);
          resolve(resp);
        }).catch(err => {
          commit("setLoading", false);
          reject(err);
        })
    })
  },
  addProduct({commit}, { data, parameters }) {
    return new Promise((resolve, reject) => {
      calls.products.post(data, parameters)
        .then(resp => {
          commit("insertProduct", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Product successfully added'
          }, { root: true });
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  addProductImage: ({commit}, { productId, data }) => {
    return new Promise((resolve, reject) => {
      calls.product.addImage(productId, data)
        .then(resp => {
          commit("insertUpdatedProduct", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  updateProduct: ({commit}, { productId, data }) => {
    return new Promise((resolve, reject) => {
      calls.product.put(productId, data).then(
        resp => {
          commit("insertUpdatedProduct", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Product successfully updated'
          }, { root: true });

          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  deleteProduct: ({commit}, productId) => {
    return new Promise((resolve, reject) => {
      calls.product.delete(productId).then(
        resp => {
          commit("removeProduct", productId);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Product successfully deleted'
          }, { root: true });

          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  }
  // toggleAllSelected: ({commit, getters}, value) => {
  //   if (value) {
  //     commit("selectAll", getters.bomIds);
  //   } else {
  //     commit("deselectAll");
  //   }
  // }
}

// mutations
const mutations = {
  setLoading(state, status) {
    state.loading = status;
  },
  setCategories(state, data) {
    state.categories = data;
  },
  insertCategory(state, data) {
    state.categories.push(data);
  },
  insertUpdatedCategory: (state, data) => {
    state.categories.forEach((category, i) => {
      if (category.id == data.id) {
        state.categories.splice(i, 1, data);
      }
    })
  },
  removeCategory: (state, categoryId) => {
    state.categories.forEach((category, i) => {
      if (category.id == categoryId) {
        state.categories.splice(i, 1);
      }
    })
  },
  setTypes(state, data) {
    state.types = data;
  },
  insertType(state, data) {
    state.types.push(data);
  },
  insertUpdatedType: (state, data) => {
    state.types.forEach((type, i) => {
      if (type.id == data.id) {
        state.types.splice(i, 1, data);
      }
    })
  },
  removeType: (state, typeId) => {
    state.types.forEach((type, i) => {
      if (type.id == typeId) {
        state.types.splice(i, 1);
      }
    })
  },
  setSubcategories(state, data) {
    state.subcategories = data;
  },
  insertSubcategory(state, data) {
    state.subcategories.push(data);
  },
  insertUpdatedSubcategory: (state, data) => {
    state.subcategories.forEach((subcategory, i) => {
      if (subcategory.id == data.id) {
        state.subcategories.splice(i, 1, data);
      }
    })
  },
  removeSubcategory: (state, subcategoryId) => {
    state.subcategories.forEach((subcategory, i) => {
      if (subcategory.id == subcategoryId) {
        state.subcategories.splice(i, 1);
      }
    })
  },
  setProducts(state, data) {
    state.pagination = data.pagination;
    state.products = data.results;
  },
  insertProduct(state, data) {
    state.products.push(data);
  },
  insertUpdatedProduct(state, data) {
    state.products.forEach((product, i) => {
      if (product.id == data.id) {
        state.products.splice(i, 1, data);
      }
    })
  },
  removeProduct(state, productId) {
    state.products.forEach((product, i) => {
      if (product.id == productId) {
        state.products.splice(i, 1);
      }
    })
  },
  setFilter(state, { field, value }) {
    state.filters[field] = value;
  },
  changePage(state, page) {
    state.pagination.page = page;
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}